"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MINIBAG_FULLSCREEN_CLASSNAME = exports.IconButton = exports.FullscreenGlobalStyles = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const IconButton = exports.IconButton = (0, _mui.styled)(_components.IconButton)((param)=>{
    let { theme } = param;
    return {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'inline-flex'
        }
    };
});
const MINIBAG_FULLSCREEN_CLASSNAME = exports.MINIBAG_FULLSCREEN_CLASSNAME = 'minibag-in-fullscreen';
const FullscreenGlobalStyles = (param)=>{
    let { isFullscreen } = param;
    const styles = (0, _react.useMemo)(()=>isFullscreen ? {
            ["#".concat(_utils.IPAPER_ROOT_ID)]: {
                height: '100dvh',
                position: 'absolute',
                top: 0,
                width: '100dvw'
            },
            ["#top-area, .".concat(MINIBAG_FULLSCREEN_CLASSNAME, ', [data-testid="Presentation-top-area-floating-banner"], [data-testid="Presentation-top-area-wallet-amount-message-banner"]')]: {
                display: 'none !important',
                zIndex: '0 !important'
            }
        } : {}, [
        isFullscreen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.GlobalStyles, {
        styles: styles
    });
};
exports.FullscreenGlobalStyles = FullscreenGlobalStyles;
